"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var prop_types_1 = __importDefault(require("prop-types"));
var react_dom_1 = __importDefault(require("react-dom"));
function Portal(_a) {
    var children = _a.children;
    var _b = react_1.useState(false), mounted = _b[0], setMounted = _b[1];
    function handleMount() {
        setMounted(true);
    }
    react_1.useEffect(handleMount, []);
    if (!mounted) {
        return null;
    }
    return react_dom_1.default.createPortal(children, document.body);
}
Portal.propTypes =
    {
        children: prop_types_1.default.element.isRequired,
    };
exports.default = Portal;
//# sourceMappingURL=index.js.map

//# sourceMappingURL={"version":3,"file":"index.js","sourceRoot":"","sources":["index.tsx"],"names":[],"mappings":";;;;;AAAA,+BAA2C;AAC3C,0DAAkC;AAClC,wDAAgC;AAEhC,SAAS,MAAM,CAAE,EAAY;QAAV,sBAAQ;IAEjB,IAAA,4BAA0C,EAAxC,eAAO,EAAE,kBAA+B,CAAA;IAEhD,SAAS,WAAW;QAEhB,UAAU,CAAE,IAAI,CAAC,CAAA;IACrB,CAAC;IAED,iBAAS,CAAE,WAAW,EAAE,EAAG,CAAC,CAAA;IAE5B,IAAI,CAAC,OAAO,EACZ;QACI,OAAO,IAAI,CAAA;KACd;IAED,OAAO,mBAAQ,CAAC,YAAY,CAAE,QAAQ,EAAE,QAAQ,CAAC,IAAI,CAAC,CAAA;AAC1D,CAAC;AAED,MAAM,CAAC,SAAS;IAChB;QACI,QAAQ,EAAE,oBAAS,CAAC,OAAO,CAAC,UAAU;KACzC,CAAA;AAED,kBAAe,MAAM,CAAA"}